import { resolveEnvironment, type Environment } from "@vellum/micro-app-auth";
import { LunaUrlMap } from "@vellum/ui";
import { UserRoles } from "@vellum/vellum-api";

const HUB_URLS: Record<Environment, string> = {
  local: "http://hub.local.vibestack.cloud",
  dev: "https://hub.dev.vellum.health",
  prod: "https://hub.vellum.health",
};

export function getHubUrl(): string {
  return HUB_URLS[resolveEnvironment()];
}

/**
 * The app page where a user's details (including home address) are edited.
 * Nurses have their own page; everyone else uses the generic user page, the
 * same split the app's own users list makes.
 */
export function appUserUrl(user: { id: string; role: UserRoles }): string {
  const isNurse =
    user.role === UserRoles.NURSE || user.role === UserRoles.FIELD_NURSE;
  return `${LunaUrlMap[resolveEnvironment()]}/${isNurse ? "nurses" : "users"}/${user.id}`;
}
